import { useGetSupportDataQuery } from 'generated/sanity-graphql';
import { useFeaturesContext } from 'state/features';

export const useSupportData = () => {
  const { featureSupportDataId = '', featureIdsLoading } = useFeaturesContext();

  const { data, loading } = useGetSupportDataQuery({
    variables: { supportDataId: featureSupportDataId },
    skip: !featureSupportDataId,
  });

  const {
    deliveryMissingItemsSubcategory,
    deliveryNeverArriveSubcategory,
    orderingIssuesCategoryGroup,
    supportCategoryGroups,
    supportDataFaqs,
  } = data?.SupportData ?? {};
  const isSupportDataLoading = featureIdsLoading || loading;

  return {
    deliveryMissingItemsSubcategory,
    deliveryNeverArriveSubcategory,
    isSupportDataLoading,
    orderingIssuesCategoryGroup,
    supportCategoryGroups,
    supportDataFaqs,
  };
};
